module.exports = __webpack_public_path__ + "static/media/icon_analysis.6805f297.svg";